export function print() {
    $("[aria-label*=\"pdf\"]").on("click", function (e) {
        window.print();
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/print.js